<template>
  <div>
    <vxe-grid
      ref="docTable"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="333"
      size="small"
      resizable
      border
      row-id="inspectionApplyDocCode"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:top>
        <div class="side-frame">
          <span class="side-frame-text">
            {{ title }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="UploadDocDialogVisible = true"
            v-if="!disabled"
            ><i class="el-icon-plus" /> {{ `${$l('btn_label_upload') || '上传'} ${title}` }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="batchDel()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>

      <template v-slot:uploadByName="{ row }">
        <div>{{ row.uploadByName }}</div>
        <div>{{ row.uploadTime }}</div>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delDoc(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <UploadDocDialog
      ref="uploadDoc"
      :title="`上传${title}`"
      :visible.sync="UploadDocDialogVisible"
      @upload="onDocUpload"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
import UploadDocDialog from '../upload-doc'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { UploadDocDialog },
  props: {
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
    inspectionApplyCode: { type: String, default: '' },
    fileType: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      UploadDocDialogVisible: false,
    }
  },

  mounted() {
    this.getTableData()
  },
  methods: {
    async getTableData() {
      if (!this.inspectionApplyCode) return
      const body = await this.$api
        .dfInspectionApplyDocListApi({
          inspectionApplyCode: this.inspectionApplyCode,
          fileType: this.fileType,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
      this.tableData = body.data || []
    },
    onDocUpload(e) {
      const { listDoc } = e
      const data = listDoc.reduce((result, next) => {
        result.push({
          ...next,
          fileType: this.fileType,
          inspectionApplyCode: this.inspectionApplyCode,
        })
        return result
      }, [])
      this.loadingOpen()
      this.$api
        .dfInspectionApplyDocSaveApi({
          itemList: data,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.getTableData()
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },

    getCheckboxRecords() {
      const $vxeGrid = this.$refs.docTable
      const data = $vxeGrid.getCheckboxRecords()
      if (!data || !data.length) return
      return data
    },
    delDoc({ inspectionApplyDocCode }) {
      this.submitDel([inspectionApplyDocCode])
    },
    batchDel() {
      const listRow = this.getCheckboxRecords()
      if (!listRow) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据!',
          type: 'warning',
        })
        return
      }

      const listInspectionApplyDocCode = listRow.map(
        (i) => i.inspectionApplyDocCode,
      )
      this.submitDel(listInspectionApplyDocCode)
    },
    submitDel(listInspectionApplyDocCode) {
      if (!listInspectionApplyDocCode || !listInspectionApplyDocCode.length)
        return
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.loadingOpen()
        this.$api
          .dfInspectionApplyDocDelApi({ listInspectionApplyDocCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！',
              )
              return
            }
            this.$message({
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getTableData()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
  },
}
</script>
